// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/dwn.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.event, .participants {
    background-color: #E4E4E4;
    gap: 48px;
    padding: 24px;
    flex-direction: column;
}
.event .title {
    font-family: Poppins;
    font-size: 20px;
    font-weight: 600;
    line-height: 150%;
}
.event .form {

}
.event .form label {
    font-family: Poppins;
    font-weight: 400;
    font-size: 16px;
    line-height: 150%;
    letter-spacing: 0px;
    color: #363636;
}
.event .form input, .event .form textarea {
    border: 1px solid #909090 !important;
}
.events-header .header-left {
    gap: 8px;
}
.events-header .header-left .header-title {
    color: #363636;
    font-family: Inter;
    font-weight: 500;
    font-size: 22px;
    line-height: 100%;
    letter-spacing: 0;
}
.header-right input {
    border: 1px solid #0A4725;
    font-family: Poppins;
    font-weight: 400;
    font-size: 16px;
    line-height: 100%;
    letter-spacing: 0;
    color: #838383;
}
.header-right button {
    font-family: Poppins;
    font-weight: 600;
    font-size: 16px;
    line-height: 100%;
    letter-spacing: 0;
    vertical-align: middle;
}
.events {
    border-collapse: separate !important;
    border-spacing: 0 10px !important;
}

.events td {
    background-color: white !important;
    padding: 12px !important;
    border-radius: 6px !important;
}
.status {
    color: #FFFFFF;
    font-family: Inter;
    font-weight: 500;
    font-size: 12px;
    line-height: 100%;
    letter-spacing: 0;

    padding-top: 5px;
    padding-right: 18px;
    padding-bottom: 5px;
    padding-left: 18px;
    border-radius: 5px;
}
.table {
    display: flex;
    flex-direction: column;
    gap: 10px; /* odstęp między wierszami */
}

.row {
    display: grid;
    grid-template-columns: 50px 1fr 150px 180px 120px 180px 100px;
    background: white;
    border-radius: 8px;
    padding: 12px;
    align-items: center;
}
.nav-wrapper {
    border-bottom: 1.5px solid #0A4725;
    padding-bottom: 16px;
    margin-bottom: 48px;
}
.nav {
    font-family: Poppins;
    font-weight: 500;
    font-size: 22px;
    line-height: 100%;
    letter-spacing: 0;
}

input[type='file'].cover-image {
    display: none;
}
label.cover-image {
    width: 100%;
    border-radius: 130px;
    background-color: #ffffff;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position-y: 20px;
    background-position-x: 97%;
    border: unset !important;
    height: 60px;

    border: 1px solid #ccc;
    display: inline-block;
    padding: 20px 20px;
    cursor: pointer;
    margin-top: -30px;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,SAAS;IACT,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;AACA;;AAEA;AACA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,oCAAoC;AACxC;AACA;IACI,QAAQ;AACZ;AACA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;AACrB;AACA;IACI,yBAAyB;IACzB,oBAAoB;IACpB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,sBAAsB;AAC1B;AACA;IACI,oCAAoC;IACpC,iCAAiC;AACrC;;AAEA;IACI,kCAAkC;IAClC,wBAAwB;IACxB,6BAA6B;AACjC;AACA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;;IAEjB,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS,EAAE,4BAA4B;AAC3C;;AAEA;IACI,aAAa;IACb,6DAA6D;IAC7D,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,kCAAkC;IAClC,oBAAoB;IACpB,mBAAmB;AACvB;AACA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;AACA;IACI,WAAW;IACX,oBAAoB;IACpB,yBAAyB;IACzB,yDAAwC;IACxC,4BAA4B;IAC5B,2BAA2B;IAC3B,0BAA0B;IAC1B,wBAAwB;IACxB,YAAY;;IAEZ,sBAAsB;IACtB,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB","sourcesContent":[".event, .participants {\n    background-color: #E4E4E4;\n    gap: 48px;\n    padding: 24px;\n    flex-direction: column;\n}\n.event .title {\n    font-family: Poppins;\n    font-size: 20px;\n    font-weight: 600;\n    line-height: 150%;\n}\n.event .form {\n\n}\n.event .form label {\n    font-family: Poppins;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 150%;\n    letter-spacing: 0px;\n    color: #363636;\n}\n.event .form input, .event .form textarea {\n    border: 1px solid #909090 !important;\n}\n.events-header .header-left {\n    gap: 8px;\n}\n.events-header .header-left .header-title {\n    color: #363636;\n    font-family: Inter;\n    font-weight: 500;\n    font-size: 22px;\n    line-height: 100%;\n    letter-spacing: 0;\n}\n.header-right input {\n    border: 1px solid #0A4725;\n    font-family: Poppins;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 100%;\n    letter-spacing: 0;\n    color: #838383;\n}\n.header-right button {\n    font-family: Poppins;\n    font-weight: 600;\n    font-size: 16px;\n    line-height: 100%;\n    letter-spacing: 0;\n    vertical-align: middle;\n}\n.events {\n    border-collapse: separate !important;\n    border-spacing: 0 10px !important;\n}\n\n.events td {\n    background-color: white !important;\n    padding: 12px !important;\n    border-radius: 6px !important;\n}\n.status {\n    color: #FFFFFF;\n    font-family: Inter;\n    font-weight: 500;\n    font-size: 12px;\n    line-height: 100%;\n    letter-spacing: 0;\n\n    padding-top: 5px;\n    padding-right: 18px;\n    padding-bottom: 5px;\n    padding-left: 18px;\n    border-radius: 5px;\n}\n.table {\n    display: flex;\n    flex-direction: column;\n    gap: 10px; /* odstęp między wierszami */\n}\n\n.row {\n    display: grid;\n    grid-template-columns: 50px 1fr 150px 180px 120px 180px 100px;\n    background: white;\n    border-radius: 8px;\n    padding: 12px;\n    align-items: center;\n}\n.nav-wrapper {\n    border-bottom: 1.5px solid #0A4725;\n    padding-bottom: 16px;\n    margin-bottom: 48px;\n}\n.nav {\n    font-family: Poppins;\n    font-weight: 500;\n    font-size: 22px;\n    line-height: 100%;\n    letter-spacing: 0;\n}\n\ninput[type='file'].cover-image {\n    display: none;\n}\nlabel.cover-image {\n    width: 100%;\n    border-radius: 130px;\n    background-color: #ffffff;\n    background-image: url('/public/dwn.svg');\n    background-repeat: no-repeat;\n    background-position-y: 20px;\n    background-position-x: 97%;\n    border: unset !important;\n    height: 60px;\n\n    border: 1px solid #ccc;\n    display: inline-block;\n    padding: 20px 20px;\n    cursor: pointer;\n    margin-top: -30px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
